import { useUrlFilterValue } from "hooks";
import { useMemo } from "react";

export const useUrlFilterValueToString = () => {
    const filterValue = useUrlFilterValue<Record<string, string>>();

    return useMemo(() => {
        const urlSearchParams = new URLSearchParams(filterValue)
        return urlSearchParams.toString()
    }, [filterValue])
}